import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    {
        id: 1,
        label: 'Dashboard',
        icon: 'bx-home-circle',
        subItems: [
            {
                id: 11,
                label: 'Manage Device',
                link: 'admin/manage-device',
                parentId: 1
            },
            {
                id: 12,
                label: 'Manage Customer',
                link: 'admin/add-whitelabel',
                parentId: 1
            },
            {
                id: 13,
                label: 'Downtime Logs',
                link: 'managefleets/downTimeLogs',
                parentId: 1
            },
        ]

    },

    {
        id: 3,
        label: 'Manage Organization',
        icon: 'bx-home-circle',
        subItems: [
            {
                id: 31,
                label: 'Organization Details',
                link: 'managefleets/manageOrganization',
                parentId: 3
            },
            {
                id: 32,
                label: 'Add Organization',
                link: 'managefleets/addOrganization',
                parentId: 3
            },
            {
                id: 33,
                label: 'Update Organization',
                link: 'managefleets/updateOrganization',
                parentId: 3
            },
            // {
            //     id: 34,
            //     label: 'VIN Eligibility',
            //     link: 'managefleets/vin-eligibility',
            //     parentId: 3
            // },
            // {
            //     id: 35,
            //     label: 'Manage VINs',
            //     link: 'managefleets/vinManagement',
            //     parentId: 3
            // },
        ]
    },
    {
        id: 15,
        label: 'Manage Group',
        icon: 'bx-sitemap',
        subItems: [
            {
                id: 151,
                label: 'Group Details',
                link: 'managefleets/manageGroup',
                parentId: 15
            },
        ]
    },
    {
        id: 5,
        label: 'Manage VINs',
        icon: 'bx-car',
        subItems: [
            {
                id: 52,
                label: 'VIN Eligibility',
                link: 'managefleets/vin-eligibility',
                parentId: 5
            },

            {
                id: 51,
                label: 'VIN Enrollment',
                link: 'managefleets/vinManagement',
                parentId: 5
            },
            {
                id: 11,
                label: 'Manage Device',
                link: 'managefleets/manage-device',
                parentId: 5
            },



        ]
    },
    {
        id: 4,
        label: 'Reports',
        icon: 'bxs-report',
        subItems: [
            {
                id: 41,
                label: 'Vehicle Forensic Report',
                link: 'managefleets/collision-report',
                parentId: 4
            },
            {
                id: 42,
                label: 'Vehicle Status',
                link: 'managefleets/Vehicle-status',
                parentId: 4
            },
            {
                id: 43,
                label: 'Vehicle Inactivity Report',
                link: 'managefleets/vin-inactive-report',
                parentId: 4
            },
            {
                id: 44,
                label: 'Telemetry Drop Report',
                link: 'managefleets/store-packet',
                parentId: 4
            },
            {
                id: 45,
                label: 'Trip Gap Report',
                link: 'managefleets/gaptTripReport',
                parentId: 4
            },
            {
                id: 46,
                label: 'Downtime',
                link: 'managefleets/downtime',
                parentId: 4
            },
        ]
    },
    {
        id: 4,
        label: 'Settings',
        icon: 'bxs-report',
        subItems: [
            // {
            //     id: 141,
            //     label: 'Notification',
            //     link: 'managefleets/setting',
            //     parentId: 4
            // },
            {
                id: 143,
                label: 'Location',
                link: 'managefleets/location',
                parentId: 4
            },
            {
                id: 144,
                label: 'Downtime Logs',
                link: 'managefleets/downTimeLogs',
                parentId: 4
            },
            {
                id: 145,
                label: 'Threshold Profile',
                link: 'managefleets/threshold-profile',
                parentId: 4
            },

        ]
    },
    // {
    //     id: 999,
    //     label: 'AI Chatbot',
    //     icon: 'bx-bot',
    //     link: 'managefleets/chat-bot',
    //   }
];

